export type FormWrapperLayoutType = 'Standard' | 'Half' | 'TwoThirds' | 'TwoColumnsLayout' | 'Full';

export enum FormWrapperLayoutModel {
  Standard = 'Standard',
  Half = 'Half',
  TwoThirds = 'TwoThirds',
  TwoColumnsLayout = 'TwoColumnsLayout',
  Full = 'Full',
}
